(function () {
  'use strict';

  var instances = window.__ecHomeOfferInstances || {};
  window.__ecHomeOfferInstances = instances;

  function safeStorage(name) {
    try {
      var storage = window[name];
      var key = '__ec_hop_test__';
      storage.setItem(key, '1');
      storage.removeItem(key);
      return storage;
    } catch (error) {
      return null;
    }
  }

  var local = safeStorage('localStorage');
  var session = safeStorage('sessionStorage');

  function parseJson(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); }
    catch (error) { return null; }
  }

  function readJson(storage, key) {
    if (!storage) return null;
    try { return JSON.parse(storage.getItem(key) || 'null'); }
    catch (error) { return null; }
  }

  function writeJson(storage, key, value) {
    if (!storage) return;
    try { storage.setItem(key, JSON.stringify(value)); }
    catch (error) { /* Storage is an enhancement, never a flow blocker. */ }
  }

  function removeStored(storage, key) {
    if (!storage) return;
    try { storage.removeItem(key); }
    catch (error) { /* Storage cleanup must never block the flow. */ }
  }

  function daysToMs(days) {
    return Number(days || 0) * 24 * 60 * 60 * 1000;
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function isVisible(element) {
    if (!element || element.hidden) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function emailIsValid(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function normalizeUsPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    return digits.length === 10 ? '+1' + digits : '';
  }

  function tagToken(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 48);
  }

  function anonymousId() {
    var key = 'ec_anonymous_id';
    var existing = local && local.getItem(key);
    if (existing) return existing;
    var value = 'ec_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
    if (local) {
      try { local.setItem(key, value); }
      catch (error) { /* Stable identity is an enhancement, never a flow blocker. */ }
    }
    return value;
  }

  function analyticsAllowed() {
    try {
      return Boolean(window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' && Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function qualifierAnswer(goal) {
    return {
      performance: 'strength_performance',
      traditional_shilajit: 'mineral_foundation',
      convenient_shilajit: 'simpler_routine',
      simple_routine: 'simpler_routine'
    }[goal] || '';
  }

  function HomeOffer(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id') || 'default';
    this.config = parseJson(root.querySelector('[data-ec-hop-config]')) || {};
    this.dialog = root.querySelector('[data-ec-hop-dialog]');
    this.reopen = root.querySelector('[data-ec-hop-reopen]');
    this.stateKey = 'ec_home_offer_' + (this.config.version || 'v1');
    this.sessionKey = this.stateKey + '_session';
    this.nativePendingKey = this.stateKey + '_native_email_pending';
    this.previousFocus = null;
    this.openedAt = 0;
    this.email = (readJson(session, this.sessionKey) || {}).email || '';
    this.busy = false;
    this.opened = false;
    this.destroyed = false;
    this.timer = null;
    this.pauseTimer = null;
    this.routeAssignmentPromise = null;
    this.inertRecords = [];
    this.state = this.readState();
    this.onScrollBound = this.onScroll.bind(this);
    this.onKeydownBound = this.onKeydown.bind(this);
    this.onFocusInBound = this.onFocusIn.bind(this);
    this.onFocusOutBound = this.onFocusOut.bind(this);
    this.onExternalOpenBound = this.onExternalOpen.bind(this);
    this.init();
  }

  HomeOffer.prototype.defaultState = function () {
    return {
      version: this.config.version || 'home_first50_v1',
      step: 'goal',
      goal: '',
      product: '',
      assignmentId: '',
      problemRoute: '',
      buildRoute: '',
      experimentVersion: '',
      emailSubmitted: false,
      smsSubmitted: false,
      smsSkipped: false,
      recommendationViewedAt: 0,
      completedAt: 0,
      tabHiddenUntil: 0,
      updatedAt: Date.now()
    };
  };

  HomeOffer.prototype.readState = function () {
    var stored = readJson(local, this.stateKey);
    if (!stored || stored.version !== (this.config.version || 'home_first50_v1')) {
      return this.defaultState();
    }
    if (stored.completedAt && Date.now() - stored.completedAt > daysToMs(this.config.completedCooldownDays || 30)) {
      return this.defaultState();
    }
    return Object.assign(this.defaultState(), stored);
  };

  HomeOffer.prototype.saveState = function (patch) {
    this.state = Object.assign({}, this.state, patch || {}, { updatedAt: Date.now() });
    writeJson(local, this.stateKey, this.state);
  };

  HomeOffer.prototype.sessionState = function () {
    return readJson(session, this.sessionKey) || {};
  };

  HomeOffer.prototype.saveSession = function (patch) {
    writeJson(session, this.sessionKey, Object.assign({}, this.sessionState(), patch || {}));
  };

  HomeOffer.prototype.hasForcePreview = function () {
    try { return new URLSearchParams(window.location.search).get('ec_offer_preview') === '1'; }
    catch (error) { return false; }
  };

  HomeOffer.prototype.hasDirectOfferRequest = function () {
    try { return new URLSearchParams(window.location.search).get('ec_offer') === '1'; }
    catch (error) { return false; }
  };

  HomeOffer.prototype.cleanDirectOfferRequest = function () {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('ec_offer') !== '1') return;
      url.searchParams.delete('ec_offer');
      window.history.replaceState(window.history.state, document.title, url.pathname + url.search + url.hash);
    } catch (error) { /* URL cleanup must never block the offer. */ }
  };

  HomeOffer.prototype.isShopifyCaptureReturn = function () {
    try { return new URLSearchParams(window.location.search).get('ec_offer_capture') === 'shopify'; }
    catch (error) { return false; }
  };

  HomeOffer.prototype.cleanInternalFormAnchor = function () {
    try {
      if (window.location.hash.indexOf('#ec-hop-email-') !== 0) return;
      var url = new URL(window.location.href);
      url.hash = '';
      window.history.replaceState(window.history.state, document.title, url.pathname + url.search);
    } catch (error) { /* URL cleanup must never block the offer. */ }
  };

  HomeOffer.prototype.setBackgroundInert = function (enabled) {
    if (!('inert' in HTMLElement.prototype)) return;
    if (!enabled) {
      this.inertRecords.forEach(function (record) {
        record.node.inert = record.inert;
        if (record.inertAttribute) record.node.setAttribute('inert', '');
        else record.node.removeAttribute('inert');
        if (record.ariaHidden === null) record.node.removeAttribute('aria-hidden');
        else record.node.setAttribute('aria-hidden', record.ariaHidden);
      });
      this.inertRecords = [];
      return;
    }
    if (this.inertRecords.length) return;
    var records = [];
    var current = this.root;
    while (current && current.parentElement && current.parentElement !== document.documentElement) {
      Array.prototype.forEach.call(current.parentElement.children, function (sibling) {
        if (sibling === current || sibling.hasAttribute('data-shopify-preview-bar-inject')) return;
        if (records.some(function (record) { return record.node === sibling; })) return;
        records.push({
          node: sibling,
          inert: Boolean(sibling.inert),
          inertAttribute: sibling.hasAttribute('inert'),
          ariaHidden: sibling.getAttribute('aria-hidden')
        });
        sibling.inert = true;
        sibling.setAttribute('inert', '');
        sibling.setAttribute('aria-hidden', 'true');
      });
      current = current.parentElement;
    }
    this.inertRecords = records;
  };

  HomeOffer.prototype.resetForcedPreview = function () {
    if (!this.hasForcePreview() || this.isShopifyCaptureReturn()) return;
    this.state = this.defaultState();
    this.email = '';
    writeJson(local, this.stateKey, this.state);
    this.saveSession({
      autoShown: false,
      completed: false,
      declined: false,
      dismissed: false,
      email: '',
      shopifyEmailPending: null
    });
    removeStored(local, this.nativePendingKey);
  };

  HomeOffer.prototype.init = function () {
    if (!this.dialog || !this.config.enabled) return;
    this.cleanInternalFormAnchor();
    this.resetForcedPreview();
    document.documentElement.classList.add('ec-hop-enabled');
    this.restoreShopifyEmailFallback();
    this.bind();
    this.showStep(this.resumeStep(), false);
    if (this.nativeEmailError) this.setError('email', this.nativeEmailError);
    if (this.nativeSmsIncomplete) {
      this.setStatus('Your email is saved. Text signup was not completed, so we continued without it.');
    }

    if (this.nativeCaptureCompleted) {
      this.scheduleOpen('shopify_capture_return', 80, true);
      return;
    }

    if (this.hasDirectOfferRequest()) {
      this.saveState({ step: 'goal', goal: '', product: '', completedAt: 0, recommendationViewedAt: 0 });
      this.cleanDirectOfferRequest();
      this.scheduleOpen('footer', 80, true);
      return;
    }

    if (this.state.tabHiddenUntil && this.state.tabHiddenUntil > Date.now()) {
      this.hideReopen();
    } else if (this.sessionState().dismissed && !this.state.completedAt) {
      this.showReopen();
    }

    if (this.hasForcePreview()) {
      this.scheduleOpen('preview', 80, true);
      return;
    }

    if (!this.isEligible()) return;
    this.timer = window.setTimeout(function () {
      this.requestOpen('timer');
    }.bind(this), Number(this.config.triggerDelayMs || 4000));
    window.addEventListener('scroll', this.onScrollBound, { passive: true });
  };

  HomeOffer.prototype.bind = function () {
    var self = this;
    this.root.querySelectorAll('[data-ec-hop-goal]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.selectGoal(button.getAttribute('data-ec-hop-goal'), button.getAttribute('data-ec-hop-product'), button);
      });
    });
    this.root.querySelectorAll('[data-ec-hop-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-ec-hop-back') || 'goal';
        self.track('ec_popup_back', { from_step: self.state.step, to_step: target });
        self.showStep(target, true);
      });
    });

    var close = this.root.querySelector('[data-ec-hop-close]');
    var decline = this.root.querySelector('[data-ec-hop-decline]');
    var emailForm = this.root.querySelector('[data-ec-hop-step="email"]');
    var smsOptIn = this.root.querySelector('[data-ec-hop-sms-opt-in]');
    var reopenButton = this.root.querySelector('[data-ec-hop-reopen-button]');
    var hideReopen = this.root.querySelector('[data-ec-hop-hide-reopen]');
    var editorOpen = this.root.querySelector('[data-ec-hop-editor-open]');
    var productCta = this.root.querySelector('[data-ec-hop-product-cta]');

    if (close) close.addEventListener('click', function () { self.dismiss('close'); });
    if (decline) decline.addEventListener('click', function () { self.dismiss('decline'); });
    if (emailForm) emailForm.addEventListener('submit', function (event) { self.submitEmail(event); });
    if (smsOptIn) {
      smsOptIn.addEventListener('change', function () { self.toggleInlineSms(); });
      self.toggleInlineSms();
    }
    if (reopenButton) reopenButton.addEventListener('click', function () { self.open('reopen', true); });
    if (hideReopen) hideReopen.addEventListener('click', function () { self.hideReopenForCooldown(); });
    if (editorOpen) editorOpen.addEventListener('click', function () { self.open('editor', true); });
    if (productCta) productCta.addEventListener('click', function (event) {
      event.preventDefault();
      self.completeAndHandoff();
      var handoff = function () {
        var product = self.config.products && self.config.products[self.state.product];
        window.location.assign(product ? self.productRoute(product) : '/');
      };
      if (!self.routeAssignmentPromise) return handoff();
      Promise.race([self.routeAssignmentPromise, wait(1800)]).then(handoff, handoff);
    });

    document.addEventListener('keydown', this.onKeydownBound);
    this.dialog.addEventListener('focusin', this.onFocusInBound);
    this.dialog.addEventListener('focusout', this.onFocusOutBound);
    document.addEventListener('ec:open-home-offer', this.onExternalOpenBound);
    document.addEventListener('ec:known-subscriber', function () {
      self.saveState({ completedAt: Date.now() });
      self.close(false);
      self.hideReopen();
    });
  };

  HomeOffer.prototype.onExternalOpen = function (event) {
    var source = event && event.detail && event.detail.source ? event.detail.source : 'external';
    this.saveState({ step: 'goal', goal: '', product: '', completedAt: 0, recommendationViewedAt: 0 });
    if (!this.opened) this.open(source, true);
    this.showStep('goal', true);
  };

  HomeOffer.prototype.isEligible = function () {
    if (this.config.suppressLoggedInCustomers && this.config.customerPresent) return false;
    if (Number(this.config.cartItemCount || 0) > 0) return false;
    if (this.state.completedAt && Date.now() - this.state.completedAt < daysToMs(this.config.completedCooldownDays || 30)) return false;
    if (this.sessionState().autoShown || this.sessionState().declined) return false;
    return true;
  };

  HomeOffer.prototype.resumeStep = function () {
    if (!this.state.goal || !this.state.product) return 'goal';
    if (!this.state.emailSubmitted) return 'email';
    return 'recommendation';
  };

  HomeOffer.prototype.onScroll = function () {
    var doc = document.documentElement;
    var max = Math.max(1, doc.scrollHeight - window.innerHeight);
    var percent = (window.scrollY / max) * 100;
    if (percent >= Number(this.config.triggerScrollPercent || 25)) {
      this.requestOpen('scroll');
    }
  };

  HomeOffer.prototype.hasCompetingOverlay = function () {
    var candidates = document.querySelectorAll('dialog[open], [aria-modal="true"], .cc-window, .pd-cp-ui, .navbar_mini-cart-holder:not(.mini-cart-closed), .w-nav-overlay');
    for (var index = 0; index < candidates.length; index += 1) {
      if (!this.dialog.contains(candidates[index]) && isVisible(candidates[index])) return true;
    }
    return false;
  };

  HomeOffer.prototype.requestOpen = function (reason) {
    if (!this.isEligible() || this.opened || this.destroyed) return;
    if (this.hasCompetingOverlay()) {
      window.clearTimeout(this.pauseTimer);
      this.pauseTimer = window.setTimeout(function () { this.requestOpen(reason); }.bind(this), 1200);
      return;
    }
    this.open(reason, false);
  };

  HomeOffer.prototype.scheduleOpen = function (reason, delay, force) {
    window.setTimeout(function () {
      if (force) this.open(reason, true);
      else this.requestOpen(reason);
    }.bind(this), delay || 0);
  };

  HomeOffer.prototype.open = function (reason, force) {
    if (this.opened || this.destroyed || (!force && !this.isEligible())) return;
    window.clearTimeout(this.timer);
    window.clearTimeout(this.pauseTimer);
    window.removeEventListener('scroll', this.onScrollBound);
    this.previousFocus = document.activeElement;
    this.opened = true;
    this.openedAt = Date.now();
    this.hideReopen();
    this.dialog.hidden = false;
    this.setBackgroundInert(true);
    document.documentElement.classList.add('ec-hop-lock');
    this.showStep(this.resumeStep(), false);
    window.requestAnimationFrame(function () {
      this.dialog.classList.add('is-open');
      this.dialog.setAttribute('tabindex', '-1');
      try { this.dialog.focus({ preventScroll: true }); }
      catch (error) { this.dialog.focus(); }
      if (document.activeElement !== this.dialog) {
        var initialControl = this.dialog.querySelector('[data-ec-hop-close]');
        if (initialControl) initialControl.focus({ preventScroll: true });
      }
    }.bind(this));
    if (reason !== 'reopen' && reason !== 'editor' && reason !== 'preview') this.saveSession({ autoShown: true });
    this.track('ec_popup_impression', { reason: reason, session_impression: 1 });
  };

  HomeOffer.prototype.close = function (restoreFocus) {
    if (!this.opened) return;
    this.opened = false;
    this.dialog.classList.remove('is-open', 'is-input-focused');
    document.documentElement.classList.remove('ec-hop-lock');
    this.setBackgroundInert(false);
    window.setTimeout(function () { this.dialog.hidden = true; }.bind(this), 230);
    if (restoreFocus !== false && this.previousFocus && typeof this.previousFocus.focus === 'function') {
      try { this.previousFocus.focus({ preventScroll: true }); }
      catch (error) { /* Ignore detached focus origins. */ }
    }
  };

  HomeOffer.prototype.dismiss = function (reason) {
    this.track('ec_popup_dismiss', {
      step: this.state.step,
      reason: reason,
      elapsed_ms: Math.max(0, Date.now() - this.openedAt)
    });
    this.saveSession({ dismissed: true, declined: reason === 'decline' });
    this.close(true);
    if (!this.state.completedAt && (!this.state.tabHiddenUntil || this.state.tabHiddenUntil <= Date.now())) this.showReopen();
  };

  HomeOffer.prototype.showReopen = function () {
    if (this.reopen && !this.state.completedAt) this.reopen.hidden = false;
  };

  HomeOffer.prototype.hideReopen = function () {
    if (this.reopen) this.reopen.hidden = true;
  };

  HomeOffer.prototype.hideReopenForCooldown = function () {
    var until = Date.now() + daysToMs(this.config.reopenHiddenDays || 7);
    this.saveState({ tabHiddenUntil: until });
    this.hideReopen();
    this.track('ec_popup_dismiss', { step: this.state.step, reason: 'reopen_tab_hidden' });
  };

  HomeOffer.prototype.showStep = function (step, focusHeading) {
    var valid = ['goal', 'email', 'recommendation'];
    if (valid.indexOf(step) === -1) step = 'goal';
    valid.forEach(function (name) {
      this.root.classList.remove('is-step-' + name);
      this.dialog.classList.remove('is-step-' + name);
    }.bind(this));
    this.root.classList.add('is-step-' + step);
    this.dialog.classList.add('is-step-' + step);
    this.root.querySelectorAll('[data-ec-hop-step]').forEach(function (screen) {
      screen.hidden = screen.getAttribute('data-ec-hop-step') !== step;
    });
    this.saveState({ step: step });
    var position = valid.indexOf(step) + 1;
    var label = this.root.querySelector('[data-ec-hop-progress-label]');
    var bar = this.root.querySelector('[data-ec-hop-progress-bar]');
    if (label) label.textContent = position + ' of 3';
    if (bar) bar.style.width = ((position / 3) * 100) + '%';
    if (step === 'recommendation') this.renderRecommendation();
    var contentInner = this.root.querySelector('.ec-hop__content-inner');
    var formScroll = this.root.querySelector('.ec-hop__form-scroll');
    if (contentInner) contentInner.scrollTop = 0;
    if (formScroll) formScroll.scrollTop = 0;
    if (focusHeading && this.opened) {
      var visible = this.root.querySelector('[data-ec-hop-step="' + step + '"]:not([hidden])');
      var heading = visible && visible.querySelector('.ec-hop__question');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
  };

  HomeOffer.prototype.selectGoal = function (goal, product, button) {
    if (!goal || !product || !this.config.products[product]) return;
    var alreadyCaptured = Boolean(this.state.emailSubmitted);
    this.saveState({
      goal: goal,
      product: product,
      assignmentId: '',
      problemRoute: '',
      buildRoute: '',
      experimentVersion: '',
      emailSubmitted: alreadyCaptured,
      smsSubmitted: alreadyCaptured ? this.state.smsSubmitted : false,
      smsSkipped: alreadyCaptured ? this.state.smsSkipped : false,
      recommendationViewedAt: 0,
      completedAt: 0
    });
    this.track('ec_popup_goal_selected', {
      goal: goal,
      recommendation: product,
      option_position: Array.prototype.indexOf.call(button.parentNode.children, button) + 1
    });
    this.requestRouteAssignment(goal, product);
    this.showStep(alreadyCaptured ? 'recommendation' : 'email', true);
  };

  HomeOffer.prototype.requestRouteAssignment = function (goal, product) {
    var endpoint = this.config.qualificationEndpoint;
    var answerId = qualifierAnswer(goal);
    if (!endpoint || !answerId || !window.fetch) return null;
    var self = this;
    this.routeAssignmentPromise = window.fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        anonymous_id: anonymousId(),
        answer_id: answerId,
        context: { product_interest: product },
        consent: { analytics: analyticsAllowed() }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('route_assignment_' + response.status);
      return response.json();
    }).then(function (assignment) {
      self.saveState({
        assignmentId: assignment.assignment_id || '',
        problemRoute: assignment.ec_problem_route || '',
        buildRoute: assignment.ec_build_route || '',
        experimentVersion: assignment.experiment_version || ''
      });
      self.track('ec_popup_route_assigned', {
        assignment_id: assignment.assignment_id || '',
        problem_route: assignment.ec_problem_route || '',
        build_route: assignment.ec_build_route || '',
        product: product
      });
      if (self.state.step === 'recommendation') self.renderRecommendation();
      return assignment;
    }).catch(function (error) {
      self.track('ec_popup_route_assignment_failed', { goal: goal, product: product, reason: error.message || 'network_error' });
      return null;
    });
    return this.routeAssignmentPromise;
  };

  HomeOffer.prototype.setError = function (name, message) {
    var node = this.root.querySelector('[data-ec-hop-' + name + '-error]');
    if (!node) return;
    node.hidden = !message;
    node.textContent = message || '';
  };

  HomeOffer.prototype.setBusy = function (name, busy) {
    var button = this.root.querySelector('[data-ec-hop-' + name + '-submit]');
    if (!button) return;
    button.disabled = Boolean(busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  HomeOffer.prototype.toggleInlineSms = function () {
    var toggle = this.root.querySelector('[data-ec-hop-sms-opt-in]');
    var fields = this.root.querySelector('[data-ec-hop-sms-fields]');
    var phone = this.root.querySelector('[data-ec-hop-phone]');
    var enabled = Boolean(toggle && toggle.checked);
    if (fields) fields.hidden = !enabled;
    if (toggle) toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');
    if (phone) phone.required = enabled;
    this.root.classList.toggle('is-sms-expanded', enabled);
    this.dialog.classList.toggle('is-sms-expanded', enabled);
    if (!enabled) this.setError('email', '');
  };

  HomeOffer.prototype.profileProperties = function () {
    return {
      ec_primary_goal: this.state.goal,
      ec_recommended_product: this.state.product,
      ec_popup_version: this.config.version,
      ec_offer: this.config.offer || 'first50',
      ec_popup_campaign: this.config.campaign
    };
  };

  HomeOffer.prototype.restoreShopifyEmailFallback = function () {
    var pending = this.sessionState().shopifyEmailPending || readJson(local, this.nativePendingKey);
    if (!pending || !pending.email) return;

    var marker = this.root.querySelector('[data-ec-hop-shopify-result]');
    var markerStatus = marker ? marker.getAttribute('data-ec-hop-shopify-result') : '';
    var returnedFromFallback = false;
    try { returnedFromFallback = new URLSearchParams(window.location.search).get('ec_offer_capture') === 'shopify'; }
    catch (error) { returnedFromFallback = false; }

    if (markerStatus === 'error') {
      this.nativeEmailError = (marker.textContent || '').trim() || 'Shopify could not save this email. Please try again.';
      this.clearShopifyEmailPending();
      this.cleanFallbackReturnMarker();
      return;
    }

    var recentNativeSubmission = Boolean(
      pending.nativeSubmissionStarted &&
      Date.now() - Number(pending.startedAt || 0) <= 15 * 60 * 1000
    );

    if (markerStatus !== 'success' && !returnedFromFallback && !recentNativeSubmission) {
      if (Date.now() - Number(pending.startedAt || 0) > 15 * 60 * 1000) {
        this.clearShopifyEmailPending();
      }
      return;
    }

    this.email = pending.email;
    this.nativeCaptureCompleted = true;
    this.saveState({ emailSubmitted: true, smsSubmitted: false, smsSkipped: true });
    this.saveSession({ email: pending.email, shopifyEmailPending: null });
    if (pending.smsRequested) this.nativeSmsIncomplete = true;
    removeStored(local, this.nativePendingKey);
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', Object.assign({ $email: pending.email }, this.profileProperties())]);
    this.track('ec_popup_email_submit', {
      goal: this.state.goal,
      recommendation: this.state.product,
      profile_status: markerStatus === 'success' ? 'accepted' : 'accepted_or_existing',
      capture_path: 'shopify_customer_fallback'
    });
    this.cleanFallbackReturnMarker();
  };

  HomeOffer.prototype.clearShopifyEmailPending = function () {
    this.saveSession({ shopifyEmailPending: null });
    removeStored(local, this.nativePendingKey);
  };

  HomeOffer.prototype.cleanFallbackReturnMarker = function () {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('ec_offer_capture');
      if (url.hash.indexOf('#ec-hop-email-') === 0) url.hash = '';
      window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
    } catch (error) { /* Query cleanup must never block the popup. */ }
  };

  HomeOffer.prototype.shopifyEmailTags = function () {
    return [
      'newsletter',
      'ec_popup_' + tagToken(this.config.campaign || 'home_first50'),
      'ec_goal_' + tagToken(this.state.goal),
      'ec_rec_' + tagToken(this.state.product),
      'ec_offer_' + tagToken(this.config.offer || 'first50')
    ].filter(function (tag) { return tag && !/_$/.test(tag); }).join(',');
  };

  HomeOffer.prototype.prepareShopifyEmailCapture = function (email, smsRequested) {
    var nativeForm = this.root.querySelector('[data-ec-hop-native-form]');
    if (!this.config.shopifyEmailFallbackEnabled || !nativeForm) return null;
    var tags = nativeForm.querySelector('[data-ec-hop-shopify-tags]');
    var returnTo = nativeForm.querySelector('[data-ec-hop-shopify-return-to]');
    var nativeEmail = nativeForm.querySelector('[data-ec-hop-native-email]');
    if (tags) tags.value = this.shopifyEmailTags();
    if (nativeEmail) nativeEmail.value = email;
    if (returnTo) {
      try {
        var returnUrl = new URL(window.location.href);
        returnUrl.searchParams.set('ec_offer_capture', 'shopify');
        returnUrl.hash = '';
        returnTo.value = returnUrl.pathname + returnUrl.search;
        window.history.replaceState({}, '', returnUrl.pathname + returnUrl.search);
      } catch (error) {
        returnTo.value = '/?ec_offer_capture=shopify';
      }
    }
    var pending = {
      email: email,
      smsRequested: Boolean(smsRequested),
      nativeSubmissionStarted: true,
      startedAt: Date.now()
    };
    this.saveSession({ shopifyEmailPending: pending });
    writeJson(local, this.nativePendingKey, pending);
    this.track('ec_popup_email_capture_started', {
      primary_provider: 'shopify_customer',
      mirror_provider: 'klaviyo_client'
    });
    return nativeForm;
  };

  HomeOffer.prototype.klaviyoSubscribe = function (attributes, channel) {
    var cfg = this.config.klaviyo || {};
    if (!cfg.publicKey || !cfg.listId) return Promise.reject(new Error('not_configured'));
    var profileAttributes = {};
    var properties = {};
    Object.keys(attributes || {}).forEach(function (key) {
      if (key === 'email' || key === 'phone_number') profileAttributes[key] = attributes[key];
      else properties[key] = attributes[key];
    });
    profileAttributes.properties = properties;
    profileAttributes.subscriptions = {};
    profileAttributes.subscriptions[channel] = { marketing: { consent: 'SUBSCRIBED' } };
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source || 'Essencraft Homepage First Subscription Offer',
          profile: { data: { type: 'profile', attributes: profileAttributes } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.publicKey), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Revision: cfg.revision || '2026-07-15' },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (response) {
      if ([200, 201, 202].indexOf(response.status) === -1) {
        var error = new Error('provider_rejected');
        error.status = response.status;
        throw error;
      }
      return response;
    });
  };

  HomeOffer.prototype.klaviyoSubscribeWithRetry = function (attributes, channel, maxAttempts) {
    var self = this;
    var attempt = 0;
    var limit = Math.max(1, Number(maxAttempts || 2));
    function run() {
      attempt += 1;
      return self.klaviyoSubscribe(attributes, channel).catch(function (error) {
        var status = Number(error.status || 0);
        var retryable = error.message !== 'not_configured' && (status === 0 || status === 429 || [500, 502, 503, 504].indexOf(status) !== -1);
        if (!retryable || attempt >= limit) {
          error.attempts = attempt;
          throw error;
        }
        self.track('ec_popup_capture_retry', { provider: 'klaviyo_client', channel: channel, attempt: attempt, status: status, error_category: error.message });
        return wait(450 * attempt).then(run);
      });
    }
    return run();
  };

  HomeOffer.prototype.submitEmail = function (event) {
    var form = event.currentTarget;
    if (form && form.getAttribute('data-ec-hop-native-dispatching') === '1') {
      form.removeAttribute('data-ec-hop-native-dispatching');
      return;
    }
    event.preventDefault();
    var nativeReady = Boolean(form && form.getAttribute('data-ec-hop-native-ready') === '1');
    if (this.busy || this.state.emailSubmitted) {
      this.showStep('recommendation', true);
      return;
    }
    var input = this.root.querySelector('[data-ec-hop-email]');
    var consent = this.root.querySelector('[data-ec-hop-email-consent]');
    var smsOptIn = this.root.querySelector('[data-ec-hop-sms-opt-in]');
    var phoneInput = this.root.querySelector('[data-ec-hop-phone]');
    var email = input ? input.value.trim() : '';
    var smsRequested = Boolean(this.config.enableSms && smsOptIn && smsOptIn.checked);
    var phone = smsRequested ? normalizeUsPhone(phoneInput ? phoneInput.value : '') : '';
    if (!emailIsValid(email)) {
      this.setError('email', 'Enter a valid email address.');
      return;
    }
    if (this.config.requireEmailConsent && consent && !consent.checked) {
      this.setError('email', 'Confirm that you would like to receive the offer by email.');
      return;
    }
    if (smsRequested && !phone) {
      this.setError('email', 'Enter a valid 10-digit U.S. mobile number, or leave text updates unchecked.');
      return;
    }
    this.setError('email', '');
    var attributes = Object.assign({ email: email }, this.profileProperties());

    var nativeForm = nativeReady ? this.prepareShopifyEmailCapture(email, smsRequested) : null;
    if (nativeReady && nativeForm) {
      form.removeAttribute('data-ec-hop-native-ready');
      this.busy = true;
      this.email = email;
      if (typeof nativeForm.requestSubmit === 'function') nativeForm.requestSubmit();
      else nativeForm.submit();
      return;
    }

    this.busy = true;
    this.setBusy('email', true);
    this.email = email;
    this.klaviyoSubscribeWithRetry(attributes, 'email', 2).then(function () {
      this.saveState({ emailSubmitted: true });
      this.saveSession({ email: email });
      this.track('ec_popup_email_submit', { goal: this.state.goal, recommendation: this.state.product, profile_status: 'accepted', capture_path: 'klaviyo_client' });
      if (!smsRequested) {
        this.saveState({ smsSubmitted: false, smsSkipped: true });
        this.track('ec_popup_sms_skip', {
          goal: this.state.goal,
          reason: 'not_selected_inline',
          consent_copy_version: (this.config.klaviyo || {}).smsConsentVersion || 'sms_home_first50_v1'
        });
        this.showStep('recommendation', true);
        return null;
      }

      var smsAttributes = Object.assign({
        phone_number: phone,
        email: email,
        ec_sms_consent_at: new Date().toISOString(),
        ec_sms_consent_copy_version: (this.config.klaviyo || {}).smsConsentVersion || 'sms_home_first50_v1'
      }, this.profileProperties());
      return this.klaviyoSubscribeWithRetry(smsAttributes, 'sms', 2).then(function () {
        this.saveState({ smsSubmitted: true, smsSkipped: false });
        this.track('ec_popup_sms_submit', {
          country: 'US',
          goal: this.state.goal,
          consent_copy_version: smsAttributes.ec_sms_consent_copy_version
        });
        this.showStep('recommendation', true);
      }.bind(this)).catch(function (smsError) {
        this.saveState({ smsSubmitted: false, smsSkipped: true });
        this.setStatus('Your email offer is saved. Text signup was not completed, so we continued without it.');
        this.track('ec_popup_sms_error', {
          error_category: smsError.message,
          status: smsError.status || 0,
          attempts: smsError.attempts || 1
        });
        this.showStep('recommendation', true);
      }.bind(this));
    }.bind(this)).catch(function (error) {
      if (this.config.shopifyEmailFallbackEnabled && form) {
        form.setAttribute('data-ec-hop-native-ready', '1');
        var button = this.root.querySelector('[data-ec-hop-email-submit]');
        if (button) button.textContent = 'SAVE WITH SHOPIFY & CONTINUE';
        this.setError('email', 'Our email service did not respond. Select the button once more to save securely with Shopify and continue.');
        this.track('ec_popup_email_fallback_ready', { error_category: error.message, status: error.status || 0, attempts: error.attempts || 1 });
      } else {
        this.setError('email', error.message === 'not_configured' ? 'Email capture is not configured yet.' : 'We could not save your email. Please try again.');
        this.track('ec_popup_email_error', { error_category: error.message, status: error.status || 0, attempts: error.attempts || 1 });
      }
    }.bind(this)).finally(function () {
      this.busy = false;
      this.setBusy('email', false);
    }.bind(this));
  };

  HomeOffer.prototype.setStatus = function (message) {
    var status = this.root.querySelector('[data-ec-hop-status]');
    if (status) status.textContent = message || '';
  };

  HomeOffer.prototype.productRoute = function (product) {
    var url;
    try { url = new URL(product.url || '/', window.location.origin); }
    catch (error) { url = new URL('/', window.location.origin); }
    url.searchParams.set('ec_popup', this.config.campaign || 'home_first50');
    url.searchParams.set('ec_goal', this.state.goal || '');
    url.searchParams.set('ec_rec', product.key || this.state.product || '');
    url.searchParams.set('ec_offer', this.config.offer || 'first50');
    url.searchParams.set('ec_offer_focus', '1');
    if (this.state.assignmentId) url.searchParams.set('ec_assignment_id', this.state.assignmentId);
    if (this.state.problemRoute) url.searchParams.set('ec_problem_route', this.state.problemRoute);
    if (this.state.buildRoute) url.searchParams.set('ec_build_route', this.state.buildRoute);
    if (this.state.experimentVersion) url.searchParams.set('ec_experiment_version', this.state.experimentVersion);
    if (product.commerceVerified && product.planId) url.searchParams.set('ec_plan', String(product.planId));
    return url.pathname + url.search;
  };

  HomeOffer.prototype.renderRecommendation = function () {
    var product = this.config.products && this.config.products[this.state.product];
    if (!product) return;
    var title = this.root.querySelector('[data-ec-hop-product-title]');
    var reason = this.root.querySelector('[data-ec-hop-product-reason]');
    var image = this.root.querySelector('[data-ec-hop-product-image]');
    var cta = this.root.querySelector('[data-ec-hop-product-cta]');
    var verified = this.root.querySelector('[data-ec-hop-verified-terms]');
    var pending = this.root.querySelector('[data-ec-hop-pending-terms]');
    var today = this.root.querySelector('[data-ec-hop-today]');
    var renewal = this.root.querySelector('[data-ec-hop-renewal]');
    if (title) title.textContent = product.title || 'Essencraft product';
    if (reason) reason.textContent = product.reason || '';
    if (image && product.image) {
      image.src = product.image;
      image.alt = product.title || 'Recommended Essencraft product';
      image.hidden = false;
    } else if (image) image.hidden = true;
    var termsAreVerified = Boolean(product.commerceVerified && product.today && product.renewal && product.planId);
    if (verified) verified.hidden = !termsAreVerified;
    if (pending) pending.hidden = termsAreVerified;
    if (today) today.textContent = product.today || '';
    if (renewal) renewal.textContent = product.renewal || '';
    if (cta) cta.href = this.productRoute(product);
    if (!this.state.recommendationViewedAt) {
      this.saveState({ recommendationViewedAt: Date.now() });
      this.track('ec_popup_recommendation_view', {
        product: product.key,
        commerce_verified: termsAreVerified,
        today_price: termsAreVerified ? product.today : '',
        renewal: termsAreVerified ? product.renewal : ''
      });
      if (!termsAreVerified) this.track('popup_price_mismatch', { product: product.key, action: 'fail_closed' });
    }
  };

  HomeOffer.prototype.completeAndHandoff = function () {
    var product = this.config.products && this.config.products[this.state.product];
    this.saveState({ completedAt: Date.now() });
    this.saveSession({ completed: true, email: '' });
    writeJson(session, 'ec_popup_attribution', {
      campaign: this.config.campaign,
      version: this.config.version,
      offer: this.config.offer,
      goal: this.state.goal,
      product: this.state.product,
      at: Date.now()
    });
    this.track('ec_popup_offer_click', {
      product: this.state.product,
      route: product ? product.url : '',
      experiment_version: this.config.version,
      commerce_verified: Boolean(product && product.commerceVerified)
    });
  };

  HomeOffer.prototype.track = function (eventName, properties) {
    var payload = Object.assign({
      event: eventName,
      campaign: this.config.campaign || 'home_first50',
      version: this.config.version || 'home_first50_v1',
      source: 'homepage_offer_popup',
      device: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
    }, properties || {});
    if (window.ecTrack) {
      window.ecTrack(eventName, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(eventName, payload);
        }
      } catch (error) { /* analytics must never block the offer */ }
    }
    window._learnq = window._learnq || [];
    window._learnq.push(['track', eventName, payload]);
  };

  HomeOffer.prototype.onKeydown = function (event) {
    if (!this.opened) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.dismiss('escape');
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), isVisible);
    if (!focusable.length) {
      event.preventDefault();
      this.dialog.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  HomeOffer.prototype.onFocusIn = function (event) {
    if (event.target && /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName)) this.dialog.classList.add('is-input-focused');
  };

  HomeOffer.prototype.onFocusOut = function () {
    window.setTimeout(function () {
      if (!this.dialog.querySelector('input:focus, textarea:focus, select:focus')) this.dialog.classList.remove('is-input-focused');
    }.bind(this), 0);
  };

  HomeOffer.prototype.destroy = function () {
    this.destroyed = true;
    window.clearTimeout(this.timer);
    window.clearTimeout(this.pauseTimer);
    window.removeEventListener('scroll', this.onScrollBound);
    document.removeEventListener('keydown', this.onKeydownBound);
    document.removeEventListener('ec:open-home-offer', this.onExternalOpenBound);
    this.close(false);
  };

  function mount(root) {
    if (!root) return;
    var id = root.getAttribute('data-section-id') || 'default';
    if (instances[id] && instances[id].destroy) instances[id].destroy();
    instances[id] = new HomeOffer(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ec-home-offer]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-ec-home-offer]');
    var id = root && root.getAttribute('data-section-id');
    if (id && instances[id]) {
      instances[id].destroy();
      delete instances[id];
    }
  });
}());
